/**
 * Class model for handling live matches from SignalR
 */
export default class LiveMatchDetailsParamsModel {
  // betRadarID, languageId, oddFormat, tenantID, searchTerm
  constructor({
    betRadarID = null,
    languageId = window.btoLangId,
    oddFormat = '0',
    tenantID = APP_SETTINGS.tenant,
    searchTerm = '',
    newWeb = true,
  }) {
    /**
     * Logged in user ID
     * @type {number}
     */
    this.betRadarID = betRadarID;
    /**
     * Tenant ID
     * @type {number}
     */
    this.tenantId = tenantID;
    /**
     *
     * @type {number}
     */
    this.languageId = languageId;
    /**
     *
     * @type {string}
     */
    this.searchTerm = searchTerm;
    /**
     *
     * @type {number}
     */
    this.oddFormat = oddFormat;
    /**
     * Param for
     * @type {boolean}
     */
    this.newWeb = newWeb;
  }

  /**
   * Load parameters as array
   * @returns {*[]}
   */
  loadParams() {
    return [
      `${this.betRadarID}`,
      this.languageId,
      +this.oddFormat,
      this.tenantId,
      this.searchTerm,
      this.newWeb,
    ];
  }
}
